import React from "react";
import { connect, dispatch } from "react-redux";
import {
  quizSelector,
  goBackToStep,
  goToStep,
  setPreviousQuestion,
  setRev
} from "redux/reducers/quiz-reducer";

class WizardToolStepIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.data.CurrentItem - 1
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleBulletClass = this.handleBulletClass.bind(this);
  }

  handleClick(e, idx) {
    e.preventDefault();
    if (idx <= this.props.currentStep) {
      this.props.setRev(true)
      this.props.setPreviousQuestion(this.props.currentStep);
      this.props.goToStep(idx);
    }

  }

  handleBulletClass(idx) {
    let currentStep = this.props.currentStep;
    if (idx < currentStep) {
      return " step-indicator__bullet--complete";
    } else if (idx === currentStep) {
      return " step-indicator__bullet--active";
    } else {
      return " step-indicator__bullet--future";
    }
  }

  render() {
    let currentStep = this.props.currentStep;
    let steps = Array.apply(
      null,
      Array(this.props.quizSettings.Items[currentStep].TotalItems)
    ).map(function () { });

    return (
      <div className={"step-indicator " + this.props.classes}>
        <div className="step-indicator__wrapper">
          {steps.map((step, idx) => {
            return (
              <a
                href="#"
                key={idx}
                onClick={e => this.handleClick(e, idx)}
                className={
                  "step-indicator__bullet" + this.handleBulletClass(idx)
                }
                id={this.props.quizSettings.pagerTrackingId + "-" + (idx + 1)}
              >
                <span className="visuallyhidden">
                  {
                    this.props.quizSettings.Settings.Labels
                      .StepIndicatorVisuallyHiddenStep
                  }{" "}
                  {idx + 1}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    quizSettings: quizSelector.quizSettings(state),
    currentStep: quizSelector.getCurrentStep(state)
  };
};

const mapDispatchToProps = {
  goToStep,
  goBackToStep,
  setPreviousQuestion,
  setRev
};

WizardToolStepIndicator = connect(
  mapStateToProps,
  mapDispatchToProps
)(WizardToolStepIndicator);
export default WizardToolStepIndicator;
